import React, { ReactElement } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'
import useBreakpointIndex from 'theme/useBreakpointIndex'

export default function TitleAndSubtitle({
  title,
  subtitle,
  updatedAt,
  dataTestId,
  sxx,
}: {
  title?: string | undefined | null
  subtitle?: string | undefined | null
  updatedAt?: string | undefined | null
  dataTestId?: string
  sxx?: ThemeUIStyleObject
}): ReactElement {
  const breakpoint = useBreakpointIndex()
  const isMobile = breakpoint === 0

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        width: '100%',
        px: ['3.2rem', '0', '0'],
        textAlign: 'center',
        gap: '1.6rem',
        maxWidth: '96rem',
        ...sxx,
      }}
    >
      <Text as="h1" variant={isMobile ? 'h1Small' : 'h1Big'} data-testid={dataTestId}>
        {title}
      </Text>
      {updatedAt && <Text sx={{ fontSize: '1.6rem' }}>{updatedAt}</Text>}
      {subtitle && (
        <Flex sx={{ justifyContent: 'center' }}>
          <Text
            className="feature-subtitle"
            sx={{ maxWidth: '72.8rem' }}
            variant={isMobile ? 'paragraphSmallRegular' : 'paragraphBigRegular'}
          >
            {subtitle}
          </Text>
        </Flex>
      )}
    </Flex>
  )
}
